import { TFunction } from 'react-i18next';

export const getActiveOptions = (t: TFunction) => [
  { value: '1', label: t('feeds_active') },
  { value: '0', label: t('feeds_disabled') },
];
